module.exports = __webpack_public_path__ + "media/images/river/shirt-carousel/shirt-6-f8482010baca1c74dcfaf5393cf44429.jpg";